import Api from 'api/api';
import { queryKeys } from 'api/queryKeys';

export const publicRegistries = {
  queryKey: queryKeys.publicRegistries,
  queryFn: Api.getPublicRegistries,
};
